import { memo } from 'react';

import { Separator, Text } from '@/components/core';
import { findField, FormatterValidatorHeader, ValidationFormSettings } from '@/components/ui';
import { useModelConfigStore } from '@/store';

export type NonEmptyValidatorProps = {
  fieldId: string;
  validatorId: string;
};

const INonEmptyValidator = ({ fieldId, validatorId }: NonEmptyValidatorProps) => {
  const field = useModelConfigStore((state) => findField(state.fields, fieldId));
  const validator = field?.validators?.find((v) => v.id === validatorId);

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <FormatterValidatorHeader validator={validator} />
      <Separator orientation="horizontal" />

      <Text>This is a required field and the value must be non-empty.</Text>

      <ValidationFormSettings fieldId={fieldId} validatorId={validatorId} />
    </div>
  );
};

export const NonEmptyValidator = memo(INonEmptyValidator) as typeof INonEmptyValidator;
